import React from 'react';
import { Box } from '@mui/material';

import { ICertificateModel } from '@common/models/Certificates/Certificate';

import DetailsPopover from '../DetailsPopover';
import {
	CertificateItemWrap,
	CertificateItemImage,
	CertificateItemInfo,
	CertificateItemInfoTitle,
} from './style';
import DownloadPopover from '../DownloadPopover';

interface CertificateItemProps {
	certificateModel: ICertificateModel;
}

function CertificateItem({ certificateModel }: CertificateItemProps) {
	return (
		<CertificateItemWrap>
			<CertificateItemImage src={certificateModel?.imgUrl} alt="Certificate image" />
			<Box display="flex" alignItems="flex-end" gap="4px" justifyContent="space-between">
				<CertificateItemInfo>
					<CertificateItemInfoTitle variant="h3" lineClamp={{ default: 2 }}>
						{certificateModel.name}
					</CertificateItemInfoTitle>
				</CertificateItemInfo>
			</Box>
			<Box display="flex" gap="8px" justifyContent="space-between">
				<DetailsPopover certificateModel={certificateModel} />
				<DownloadPopover certificateModel={certificateModel} />
			</Box>
		</CertificateItemWrap>
	);
}

export default CertificateItem;
